import _ from "lodash";
import UserConstants from './UserConstants';

const defaultState = window.state ? window.state.users : {};

export function users(state = defaultState, action) {
    switch (action.type) {
        case UserConstants.USER_RECEIVED:
            return {
                ...state,
                [action.payload.id.toString()]: {
                    id: action.payload.id.toString(),
                    name: action.payload.name.toString(),
                    email: action.payload.email.toString(),
                }
            };
        case UserConstants.TEAM_MEMBER_REMOVED:
            return _.filter(state, user => user.id !== action.payload.id );
        default:
            return state;
    }
}

export function invites(state = {}, action) {
    switch (action.type) {
        case UserConstants.INVITE_RECEIVED:
            return {
                ...state,
                [action.payload.id.toString()]: {
                    id: action.payload.id.toString(),
                    account_id: action.payload.account_id.toString(),
                    email: action.payload.email.toString(),
                }
            }
        case UserConstants.INVITE_REVOKED:
            return _.filter(state, invite => invite.id !== action.payload.id );
        default:
            return state;
    }
}
